import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import Promise from 'bluebird';

const applications = [
  ['activation-app', () => import ('./ActivationApp')],
]

const renderApp = async ([id, loader]) => {
  var target = document.getElementById(id);

  if (target) {
    var module = await loader();
    var App = module.default;

    ReactDOM.render(<App />, target);
    return true;
  }

  return false;
}

try {
Promise.map( applications, renderApp).then( (loaded) => {
  if (loaded.some( (x) => x )) {
    registerServiceWorker();
  }
});
} catch (error) {
  var message=error.message();
}


